import React, { useState, useEffect } from "react";
import "../../components/Stages/Stages.css";
import axios from "axios";

const Stages = ({tokenStorage,openProfile,setOpenProfile,selectedStageId}) => {
  const [statusResponse, setStatusResponse] = useState([]);

  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);
    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETStages?StageID=` + selectedStageId + `&StatusID=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setFirstItem(response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const [firstItem, setFirstItem] = useState({
    stageid: "",
    statusid: selectedStageId,
    // StatusName: "",
    stagename: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setFirstItem({
      stageid: selectedStageId,
    });
    
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddStage`,
        firstItem, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      // Optionally, reset the form
      setFirstItem({
        // StatusName: "",
        stagename: "",
      });
      tokenStorage();
      setOpenProfile (!openProfile);
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  // -----------------------------status-----------------------
  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETStatus?ID=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setStatusResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  return (
    
    <div className="container-fluid">
      <br />

      <div className="stagesDetail">
        <form className="stages-form">
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Status Name*</td>
              <td>Stages Name*</td>
            </tr>

            <tr>
              <td>
                {/* <input type="text" name="StatusName"  placeholder="Enter Please" onChange={handleChange}/> */}
                <select
                    className="dropdown-employee"
                    name="statusid"
                    value={firstItem.statusid}  
                    onChange={handleChange}                 
                    style={{ height: "29px", width: "13rem" }}
                  >
                    <option value="">Select an option</option>
                    {statusResponse.map((item) => (
                      <option value={item.statusid}>{item.statusname}</option>
                    ))}
                  </select>
              </td>
              <td>
                <input type="text" name="stagename" value={firstItem.stagename} placeholder="Enter Please" onChange={handleChange}/>
              </td>
            
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addStages-button">
          <button  type="submit" onClick={handleSubmit}  style={{marginRight: "10px", backgroundColor: "#5B489D", color: "white"}}>
              Apply
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
           
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default Stages;
